import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   addLaneMasterApiCall,
   getAllLaneApiCall,
   getAllVendorsApiCall,
   listLaneMasterApiCall,
   updateLaneApiCall,
} from "../../Api/api";
import client from "../../Api/client";

// initial state
const initialState = {
   dataList: [],
   singleLane: null,

   allLanes: [],
   allVendors: [],

   contractors: [],

   isLoading: false,
   isError: false,
   isSuccess: false,
};

// add lane
export const addLaneMasterAsync = createAsyncThunk(
   "customerMaster/add-customer-master",
   async ({ data, err, done }, thunkAPI) => {
      try {
         ;
         const response = await addLaneMasterApiCall(data);
         

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// list of all lane master
export const listLaneMasterAsync = createAsyncThunk(
   "driverMaster/list-driver-master",
   async ({ err, done }, thunkAPI) => {
      try {
         const response = await listLaneMasterApiCall();
         

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// add fleet
export const getAllLaneAsync = createAsyncThunk(
   "driverMaster/getAllLaneAsync",
   async (data, thunkAPI) => {
      try {
         ;
         const response = await getAllLaneApiCall();
         

         if (response.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// add fleet
export const getAllVendorAsync = createAsyncThunk(
   "driverMaster/getAllVendorAsync",
   async (data, thunkAPI) => {
      try {
         ;
         const response = await getAllVendorsApiCall();
         

         if (response.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// fetch single customer master
export const fetchSingleLaneMasterAsync = createAsyncThunk(
   "laneMaster/fetch-single-lane master",
   async ({ id, err, done }, thunkAPI) => {
      try {
         const response = await client.get(
            `lane-cust-vend-map/fetch/${id}?&model_id=8&action_id=3`,
            {
               headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
               },
            }
         );
         

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// update Lane
export const updateLaneAsync = createAsyncThunk(
   "lane/update-lane",
   async ({ data, err, done }, thunkAPI) => {
      try {
         ;
         const response = await updateLaneApiCall(data);
         

         if (response.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// fleet master slice
const laneMasterSlice = createSlice({
   name: "laneMaster",

   initialState: initialState,

   reducers: {
      clearDriverMasterState: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      //
      builder.addCase(listLaneMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(listLaneMasterAsync.fulfilled, (state, action) => {
         
         state.isLoading = false;
         state.dataList = action.payload;
      });
      builder.addCase(listLaneMasterAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(getAllVendorAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(getAllVendorAsync.fulfilled, (state, action) => {
         
         state.isLoading = false;
         state.allVendors = action.payload;
      });
      builder.addCase(getAllVendorAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(getAllLaneAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(getAllLaneAsync.fulfilled, (state, action) => {
         
         state.isLoading = false;
         state.allLanes = action.payload;
      });
      builder.addCase(getAllLaneAsync.rejected, (state, action) => {
         state.isLoading = false;
      });

      //
      builder.addCase(fetchSingleLaneMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchSingleLaneMasterAsync.fulfilled, (state, action) => {
         
         state.isLoading = false;
         state.singleLane = action.payload;
      });
      builder.addCase(fetchSingleLaneMasterAsync.rejected, (state, action) => {
         state.isLoading = false;
      });
   },
});

export const { clearDriverMasterState } = laneMasterSlice.actions;

const laneMasterReducer = laneMasterSlice.reducer;
export default laneMasterReducer;
